import { createStyles } from "@mantine/emotion";
import { CSSProperties } from "react";
import { Link } from "react-router-dom";
import { linkColor } from "../../utils";
import "./CustomLink.css";

type Props = {
  to: string;
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLAnchorElement> | undefined;
  fontSize?: string | number;
  target?: string;
  ellipsis?: boolean;
};

interface MyComponentStyles extends CSSProperties {
  fontSize?: string | number;
}

const useStyles = createStyles((theme, { fontSize }: MyComponentStyles) => ({
  link: {
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
      cursor: "pointer",
    },
    // color: "#1c7ed6",
    color: linkColor,
    fontSize: fontSize,
    fontWeight: 400,
  },
  disabledLink: {
    "&:hover": {
      textDecoration: "none",
      cursor: "not-allowed",
    },
    fontSize: fontSize,
    fontWeight: 400,
    color: "#a0a0a0",
  },
}));

export const CustomLink = ({
  to,
  children,
  disabled,
  onClick,
  fontSize = "14px",
  target,
  ellipsis = false,
}: Props) => {
  const { classes } = useStyles({ fontSize });
  return (
    <>
      {disabled ? (
        <span className={classes.disabledLink}>{children}</span>
      ) : (
        <Link
          to={to}
          className={ellipsis ? `${classes.link} ellipsis` : classes.link}
          onClick={onClick}
          target={target || "_self"}
        >
          {children}
        </Link>
      )}
    </>
  );
};
